export const COLORS = {
  accent: '#1A6B3C',
  accentMid: '#3DAA6A',
  accentLight: '#E8F5EE',
  ink: '#0d2d1a',
  inkMid: '#444',
  inkLight: '#888',
  white: '#ffffff',
  bg: '#F8FAF9',
  border: '#E5EDE8',
  danger: '#DC2626',
  dangerLight: '#FEE2E2',
  gold: '#C89B2A',
  goldLight: '#FDF6E3',
};